import { Component, OnInit } from '@angular/core';
import { AllapiService } from 'src/app/allapi.service';

@Component({
  selector: 'app-mississauga-panthers',
  templateUrl: './mississauga-panthers.component.html',
  styleUrls: ['./mississauga-panthers.component.css']
})
export class MississaugaPanthersComponent implements OnInit {
  deviceStatus: string;
  yearname: any = 2019;

  teamPlayers: any[] = [
    {
      'profileimg': 'Shoiab Malik.png',
      'PlayerName': 'Shoaib Malik',
      'Specialization': 'all rounder',
    },
    {
      'profileimg': 'Chris Gayle.png',
      'PlayerName': 'Chris Gayle',
      'Specialization': 'all rounder',
    },
    {
      'profileimg': 'Azam Khan.png',
      'PlayerName': 'Azam Khan',
      'Specialization': 'Wicketkeeper Batter',
    },
    {
      'profileimg': 'James Neesham.png',
      'PlayerName': 'James Neesham',
      'Specialization': 'all rounder',
    },
    {
      'profileimg': 'Cameron Delport.png',
      'PlayerName': 'Cameron Scott Delport',
      'Specialization': 'Batter',
    },
    {
      'profileimg': 'player-default.png',
      'PlayerName': 'Usman Qadir',
      'Specialization': 'bowler',
    },
    {
      'profileimg': 'Zahoor Khan.png',
      'PlayerName': 'Zahoor Khan',
      'Specialization': 'bowler',
    },
    // {
    //   'profileimg': 'Shahnawaz Dahani.png',
    //   'PlayerName': 'Shahnawaz Dahani',
    //   'Specialization': 'bowler',
    // },
    {
      'profileimg': 'Tom Cooper.png',
      'PlayerName': 'Tom Cooper',
      'Specialization': 'Batter',
    },
    {
      'profileimg': 'Cecil Pervez.png',
      'PlayerName': 'Cecil Pervez',
      'Specialization': 'bowler',
    },
    {
      'profileimg': 'player-default.png',
      'PlayerName': 'Jaskarandeep Singh Buttar',
      'Specialization': 'bowler',
    },
    {
      'profileimg': 'Navneet Dhaliwal.png',
      'PlayerName': 'Navneet Dhaliwal',
      'Specialization': 'Batter',
    },
    {
      'profileimg': 'Nikhil Dutta.png',
      'PlayerName': 'Nikhil Dutta',
      'Specialization': 'bowler',
    },
    {
      'profileimg': 'Shreyas Movva.png',
      'PlayerName': 'Shreyas Movva',
      'Specialization': 'Wicketkeeper Batter',
    },
    {
      'profileimg': 'player-default.png',
      'PlayerName': 'Parveen Kumar',
      'Specialization': 'all rounder',
    },
    {
      'profileimg': 'Mihir patel.png',
      'PlayerName': 'Mihir Patel',
      'Specialization': 'all rounder',
    },
    {
      'profileimg': 'player-default.png',
      'PlayerName': 'Ethan Gibson',
      'Specialization': 'Batter',
    }
  ]
  yearnameforimage: string = '2024';
  constructor(private server: AllapiService) {
  }
  getSquadJson() {
    if (this.yearnameforimage == '2024') {
      this.teamPlayers = [
    {
        'profileimg': 'Shakib Al Hasan.png',
        'PlayerName': 'Shakib al Hasan',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Iftikhar Ahmed.png',
        'PlayerName': 'Iftikhar Ahmed',
        'Specialization': 'Batter All Rounder',
    },
    {
        'profileimg': 'Rahmanullah Gurbaz.png',
        'PlayerName': 'Rahmanullah Gurbaz',
        'Specialization': 'WK-Batsman',
    },
    {
        'profileimg': 'Hazratullah Zazai.png',
        'PlayerName': 'Hazratullah Zazai',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Shoriful Islam.png',
        'PlayerName': 'Shoriful Islam',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Odean Smith.png',
        'PlayerName': 'Odean Smith',
        'Specialization': 'Bowling All Rounder',
    },
    {
        'profileimg': 'David Wiese.png',
        'PlayerName': 'David Weise',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Muhammad Waseem.png',
        'PlayerName': 'Md Waseem',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Farhan Khan.png',
        'PlayerName': 'Farhan Khan',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Nav Pabreja.png',
        'PlayerName': 'Nav Pabreja',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Pargat Singh.png',
        'PlayerName': 'Pargat Singh',
        'Specialization': 'All Rounder',
    },
    {
      'profileimg': 'DILON.png',
      'PlayerName': 'Dilon Heylliger',
      'Specialization': 'Bowler',
    },
    {
      'profileimg': 'Rayyan PATHAN.png',
      'PlayerName': 'Rayyan Pathan',
      'Specialization': 'Batting Allrounder',
    },
    {
        'profileimg': 'Gurpal Singh Sidhu.png',
        'PlayerName': 'Gurpal Sidhu',
        'Specialization': 'Batting Allrounder',
    },
    {
        'profileimg': 'Tajinder Singh.png',
        'PlayerName': 'Tajinder Singh',
        'Specialization': 'Batting Allrounder',
    },
    {
        'profileimg': 'NAVJOT DOSANJH.png',
        'PlayerName': 'Navjot Dosanjh',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'RAVINDER RREDDY.png',
        'PlayerName': 'Ravinder Reddy',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'GURBAZ BAJWA.png',
        'PlayerName': 'Gurbaz Bajwa',
        'Specialization': 'Batter',
    },
];

    } else if (this.yearnameforimage == '2023') {
      this.teamPlayers = [
        {
          'profileimg': 'Shoiab Malik.png',
          'PlayerName': 'Shoaib Malik',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Chris Gayle.png',
          'PlayerName': 'Chris Gayle',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Azam Khan.png',
          'PlayerName': 'Azam Khan',
          'Specialization': 'Wicketkeeper Batter',
        },
        {
          'profileimg': 'James Neesham.png',
          'PlayerName': 'James Neesham',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Cameron Delport.png',
          'PlayerName': 'Cameron Scott Delport',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Usman Qadir',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Zahoor Khan.png',
          'PlayerName': 'Zahoor Khan',
          'Specialization': 'bowler',
        },
        // {
        //   'profileimg': 'Shahnawaz Dahani.png',
        //   'PlayerName': 'Shahnawaz Dahani',
        //   'Specialization': 'bowler',
        // },
        {
          'profileimg': 'Tom Cooper.png',
          'PlayerName': 'Tom Cooper',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Cecil Pervez.png',
          'PlayerName': 'Cecil Pervez',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Jaskarandeep Singh Buttar',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Navneet Dhaliwal.png',
          'PlayerName': 'Navneet Dhaliwal',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Nikhil Dutta.png',
          'PlayerName': 'Nikhil Dutta',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Shreyas Movva.png',
          'PlayerName': 'Shreyas Movva',
          'Specialization': 'Wicketkeeper Batter',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Parveen Kumar',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Mihir patel.png',
          'PlayerName': 'Mihir Patel',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Ethan Gibson',
          'Specialization': 'Batter',
        }
      ]
    }
  }
  SquadData(year:string): void {
    if (year !== '2023') {
      this.yearname = year;
    }
    this.yearnameforimage = year;
    this.teamPlayers = [];
    this.getSquadJson();
  }

  ngOnInit() {
    this.getInnerHeight();
    this.getSquadJson();
  }
  getInnerHeight(): void {
    this.deviceStatus = this.server.checkSystemWidth();
    console.log('this.deviceStatus :>> ', this.deviceStatus);
  }
}
